import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { rootRoute } from './root'
import { RouteError } from '@lunary/ui-web/screen-state'

export const readingsRoute = createRoute({
  path: 'readings',
  getParentRoute: () => rootRoute,
  component: lazyRouteComponent(() => import('../features/readings/page'), 'ReadingsPage'),
  errorComponent: RouteError,
})
